import React from 'react';
import './Columns.scss';

function Columns({
    children
}) {
    children = Array.isArray(children) ? children : [children];
    return <div className="columns">
        {children.filter(c => c).map((child, i) => <div key={i} className="column">{child}</div>)}
    </div>;
}

export default Columns;